export const cellPhoneIcon = [
      '65 65',
  `<g id="Grupo_251" data-name="Grupo 251" transform="matrix(1.861792, 0, 0, 3.031189, -27.510342, -604.398743)" opacity="0.8" style="">
    <g id="Rectángulo_330" data-name="Rectángulo 330" transform="matrix(0.935129, 0, 0, 1.146596, 16, 199.812592)" fill="none" stroke="#47b2e5" stroke-width="1.6" style="">
      <rect width="21" height="15" rx="5" stroke="none"/>
      <rect x="0.8" y="0.8" width="21.521" height="16.456" rx="4.2" fill="none"/>
    </g>
    <line id="Línea_48" data-name="Línea 48" x2="32.364" fill="none" stroke-width="1.6" style="stroke-linecap: round;" stroke="#47b2e5" x1="22.001" y1="203.296" y2="203.296"/>
    <line id="Línea_49" data-name="Línea 49" x2="26.465" fill="none" stroke-width="1.6" style="stroke-linecap: round; transform-origin: 3.813px 217.133px;" stroke="#47b2e5" x1="26.882" y1="217.233" y2="217.233"/>
  </g>`,
  ];